<template>
  <div class="pricing-page">
    <!-- 横幅部分 -->
    <section class="hero-banner bg-orange-500 py-16 lg:py-20">
      <div class="max-w-7xl mx-auto px-4 lg:px-8">
        <div class="flex flex-col lg:flex-row items-center justify-between gap-8 lg:gap-12">
          <!-- 左侧内容 -->
          <div class="flex-1 text-center lg:text-left">
            <h1 class="text-3xl lg:text-4xl xl:text-5xl font-bold text-white mb-6 leading-tight">
              {{ $t('pricing.title') }}
            </h1>
            <p class="text-xl text-white mb-0 opacity-90">
              {{ $t('pricing.subtitle') }}
            </p>
          </div>

          <!-- 右侧图标 -->
          <div class="flex-shrink-0 w-64 h-64 lg:w-80 lg:h-80">
            <img src="/assets/23@1x.png" alt="收费标准" class="w-full h-full object-contain">
          </div>
        </div>
      </div>
    </section>

    <!-- 主要内容 -->
    <section class="content-section py-16 bg-white">
      <div class="max-w-4xl mx-auto px-4 lg:px-8">
        <div class="prose max-w-none">
          <h2>{{ $t('pricing.sections.commission.title') }}</h2>
          <p>{{ $t('pricing.sections.commission.content') }}</p>

          <h2>{{ $t('pricing.sections.fees.title') }}</h2>
          <p>{{ $t('pricing.sections.fees.content') }}</p>

          <h2>{{ $t('pricing.sections.other.title') }}</h2>
          <p>{{ $t('pricing.sections.other.content') }}</p>

          <h2>{{ $t('pricing.sections.payment.title') }}</h2>
          <p>{{ $t('pricing.sections.payment.content') }}</p>

          <div class="mt-12 p-6 bg-orange-50 rounded-lg border border-orange-200">
            <h3 class="text-lg font-semibold text-orange-900 mb-2">{{ $t('pricing.notice.title') }}</h3>
            <p class="text-orange-800">{{ $t('pricing.notice.content') }}</p>
          </div>

          <div class="mt-10 text-center">
            <button
              type="button"
              @click="downloadFeeTable"
              :disabled="downloading"
              class="inline-flex items-center justify-center bg-[#ef7c5b] hover:bg-[#e26c49] text-white px-8 py-3 rounded-full font-semibold transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <svg v-if="downloading" class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              {{ downloading ? '下载中...' : '查看收费表' }}
            </button>
          </div>
        </div>
      </div>
    </section>

    <!-- Toast 提示 -->
    <transition name="toast">
      <div v-if="showToast" class="fixed top-20 left-1/2 transform -translate-x-1/2 z-50 bg-green-500 text-white px-6 py-3 rounded-lg shadow-lg flex items-center gap-3">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
        </svg>
        <span class="font-medium">下载已开始，请查看浏览器下载</span>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'PricingPage',
  metaInfo: {
    title: '收费标准 - 红土证券'
  },
  data() {
    return {
      downloading: false,
      showToast: false
    };
  },
  methods: {
    downloadFeeTable() {
      this.downloading = true;

      const filePath = '/assets/shoufei/紅土證券收費表——總表.pdf';

      // 在新标签页打开PDF,用户可以选择下载位置
      window.open(filePath, '_blank');

      // 1秒后显示下载完成提示
      setTimeout(() => {
        this.downloading = false;
        this.showToast = true;

        // 3秒后自动隐藏提示
        setTimeout(() => {
          this.showToast = false;
        }, 3000);
      }, 1000);
    }
  }
};
</script>

<style scoped>
.hero-banner {
  background: #ef7c5b;
  position: relative;
  overflow: hidden;
}

.hero-banner::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="25" cy="25" r="1" fill="rgba(255,255,255,0.1)"/><circle cx="75" cy="75" r="1" fill="rgba(255,255,255,0.1)"/><circle cx="50" cy="10" r="0.5" fill="rgba(255,255,255,0.1)"/><circle cx="10" cy="50" r="0.5" fill="rgba(255,255,255,0.1)"/><circle cx="90" cy="30" r="0.5" fill="rgba(255,255,255,0.1)"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>');
  opacity: 0.3;
}

.content-section {
  min-height: 600px;
}

/* 富文本内容样式 */
.prose >>> h1 {
  font-size: 1.875rem;
  font-weight: 700;
  margin-top: 1.5em;
  margin-bottom: 0.75em;
  line-height: 1.2;
  color: #111827;
}

.prose >>> h2 {
  font-size: 1.5rem;
  font-weight: 600;
  margin-top: 2em;
  margin-bottom: 0.75em;
  line-height: 1.3;
  color: #111827;
  padding-bottom: 0.5em;
  border-bottom: 2px solid #f97316;
}

.prose >>> h3 {
  font-size: 1.25rem;
  font-weight: 600;
  margin-top: 1.5em;
  margin-bottom: 0.5em;
  line-height: 1.4;
  color: #111827;
}

.prose >>> p {
  margin-top: 0.5em;
  margin-bottom: 1em;
  line-height: 1.75;
  color: #4b5563;
}

.prose >>> ul {
  list-style-type: disc;
  padding-left: 1.5em;
  margin-top: 0.75em;
  margin-bottom: 1em;
}

.prose >>> ol {
  list-style-type: decimal;
  padding-left: 1.5em;
  margin-top: 0.75em;
  margin-bottom: 1em;
}

.prose >>> li {
  margin-top: 0.5em;
  margin-bottom: 0.5em;
  line-height: 1.75;
  color: #4b5563;
}

.prose >>> li::marker {
  color: #f97316;
}

.prose >>> strong {
  font-weight: 700;
  color: #111827;
}

.prose >>> em {
  font-style: italic;
}

.prose >>> a {
  color: #ea580c;
  text-decoration: underline;
  transition: color 0.2s;
}

.prose >>> a:hover {
  color: #c2410c;
}

.prose >>> ul ul,
.prose >>> ol ul,
.prose >>> ul ol,
.prose >>> ol ol {
  margin-top: 0.5em;
  margin-bottom: 0.5em;
}

/* 移动端响应式调整 */
@media (max-width: 768px) {
  .hero-banner {
    padding: 3rem 1rem;
  }

  .hero-banner h1 {
    font-size: 1.75rem;
  }

  .content-section {
    padding: 3rem 1rem;
  }
}

/* Toast 动画 */
.toast-enter-active, .toast-leave-active {
  transition: all 0.3s ease;
}

.toast-enter, .toast-leave-to {
  opacity: 0;
  transform: translate(-50%, -20px);
}

.toast-enter-to, .toast-leave {
  opacity: 1;
  transform: translate(-50%, 0);
}
</style>
